"use client"

import { useState, useCallback } from "react"
import { useRouter } from "next/navigation"
import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import Sentry from '@/lib/sentry-safe'

export function SoundsNav404() {
  const router = useRouter()
  const [query, setQuery] = useState("")

  // No autofocus on mount (TES-2186). A 404 is the page a keyboard or screen
  // reader user is likeliest to reach by accident, and stealing focus into this
  // field on load skipped the layout's skip link (it precedes the input in DOM
  // order, so only Shift+Tab could reach it) and announced a text field before
  // the "404 / This page drove off" heading. Focus starts on <body> like every
  // other route.
  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault()
    if (query.trim()) {
      router.push(`/sounds?q=${encodeURIComponent(query.trim())}`)
    }
  }, [query, router])

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <label htmlFor="404-search" className="text-sm text-[var(--tls-fg-muted)] block">
        Search for a sound:
      </label>
      <div className="flex gap-2">
        <Input
          id="404-search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Star Wars, Minecraft, Portal..."
          aria-label="Search for Tesla lock sounds"
        />
        {/* One accent-filled primary per panel — the 404 panel already spends
            it on "Browse sounds", so this is the outlined secondary icon
            button (pill radius, 44px target). */}
        <Button
          type="submit"
          variant="outline"
          size="icon"
          aria-label="Search sounds"
        >
          <Search className="size-4" />
        </Button>
      </div>
    </form>
  )
}
